<app-loader></app-loader>
<router-outlet></router-outlet>
<notifier-container></notifier-container>